import React from "react";
import { Helmet } from "react-helmet";
//import React, { useState, useContext } from 'react';
import "./style.css";
import NotificationBadge from 'react-notification-badge';
//import { Effect } from 'react-notification-badge';
import { Redirect } from 'react-router-dom';
// import Button from 'components/Button/Button';
import axios from "axios";
// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import { Container } from 'react-bootstrap';
// , Col, Row
// import Modal from 'react-bootstrap/Modal';
import OnboardingModal from 'components/Modals/OnboardingModal';
import SignupModal from 'components/Modals/SignupModal';
import VerificationModal from 'components/Modals/VerificationModal';
// import Form from "react-bootstrap/Form";
import light_mode_logo from "Assets/logo.svg";
import dark_mode_logo from "Assets/dark_mode_pk_logo.svg";
//import dark_mode_logo from "Assets/logo.svg";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Route, Switch, withRouter, NavLink, Link } from "react-router-dom";
import Events from "../../pages/Events/Events";
import EventDetail from "pages/EventDetails/EventDetails";
import Channels from "pages/Channels/Channels";
import Player from "pages/Player/Player";
import Pricing from "pages/Pricing/Pricing";
import QuickCreate from "pages/QuickCreate/QuickCreate"; // pkmaker
import GetOnWithIt from "pages/GetOnWithIt/GetOnWithIt";
import EmbeddedPlayer from "pages/Player/EmbeddedPlayer";
import Login from "pages/LoginPage/LoginForm/Login";
import pkCreation from "pages/PKCreation/PKCreation";
import Register from "pages/LoginPage/RegisterForm/Register/Register";
import AboutYourself from "pages/LoginPage/RegisterForm/AboutYourself/AboutYourself";

//import VideoChatControl from "pages/VideoChats/VideoChatControl";
import AgoraVideoChatControl from "pages/VideoChats/AgoraVideoChatControl";

//import VideoChat from "pages/VideoChats/VideoChat";
import AgoraVideoChat from "pages/VideoChats/AgoraVideoChat";


import Groups from "pages/Groups/Groups";
import GroupDetails from "pages/Groups/GroupDetails";
import RunofShowPlay from "pages/EventDetails/RunOfShow/RunOfShowPlay";
import AboutPage from "pages/About/About";
import HomePage from "pages/Home/HomePage";
import WorkspaceHomePage from "pages/Home/WorkspaceHomePage";
import City from "pages/City/City";
import CityList from "pages/City/CityList";
//import PkList from 'pages/PKList/PkList';
import MyPks from 'pages/PKList/MyPks';
import Category from 'pages/Categories/Category';
import ResetPassword from 'pages/LoginPage/ResetPassword/ResetPassword';
import EmailVerification from 'pages/LoginPage/ResetPassword/EmailVerification';
import searchResults from 'pages/Search/SearchResults';
import AccountSettings from 'pages/LoginPage/AccountSettings/AccountSettings';
import categoryDetail from "pages/Categories/CategoryDetails";
import PrivacyPolicy from "pages/Conditions/PrivacyPolicy/PrivacyPolicy";
import TermsofUse from "pages/Conditions/TermsOfUse/TermsofUse";
import CopyRights from "pages/Conditions/CopyRights/CopyRights";
import { get_current_unix_stamp, getRelativeTime, getQueryString } from 'utils/Helper';
import Channelsdetail from 'pages/ChannelDetail/ChannelDetails';
import Banner from 'components/Banner/Banner';
import NotFound from 'components/NotFound/NotFound';
import UnknownError from 'components/NotFound/UnknownError';
import AccessRequired from 'components/NotFound/AccessRequired';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import Profile from 'pages/Profile/Profile';
import { get_user_info, get_user_notifications } from 'Api/GetUserInfo';
import { user_access_token, searchUrl, user_access_token_expiration, user_account_level, grabFromLocalStorage, org_name, org_friendly_url, owner_perms, organization_user_access_level, apiUrl, user_access_level, user_entity_uuid, myHeaders_Authorized, user_Status, user_Status_Ver, user_API } from "Api/Api";
// , myHeaders_Auth_With_Cache_Control, org_account_level
import { setLocalStorageSubVal } from 'utils/Helper';
// , getKey, saveKey
//import Schools from 'pages/ForSchools/Schools';
//import Business from 'pages/ForBusiness/Business';
//import Hostevent from 'pages/HostEvent/Hostevent';
import Press from 'pages/Press/Press';
import Jobs from 'pages/Jobs/Jobs';
import InternationalPk2022 from 'pages/InternationalPkDay/InternationalPk2022';
import InternationalPk2021 from 'pages/InternationalPkDay/InternationalPk2021';
import InternationalPk2020 from 'pages/InternationalPkDay/InternationalPk2020';
import CreativeGames from 'pages/CreativeGames/CreativeGames';
import ManageCity from 'pages/City/EditCity/EditCity';
import ManageChannel from 'pages/Channels/EditChannel/EditChannel';
import Dropdown from 'react-bootstrap/Dropdown';
import avatar from 'Assets/avatarnew.svg';
import PkCreateHome from 'pages/PKCreateHome/PkCreateHome';
import { local_routes, feature_names } from 'utils/Routes';
import ManageEvent from 'pages/CreateEvent/CreateEvent';
//import ChannelManageEvents from 'pages/CreateChannelEvents/CreateChannelEvent';
import ManageWorkspace from 'pages/ManageWorkspace/ManageWorkspace';
import ManagePechaKucha from 'pages/ManagePechaKucha/ManagePechaKucha';
import MyEvents from 'pages/EventList/MyEvents';
import EventCalendar from 'pages/EventCalendar/EventCalendar';

import RingTophat from 'components/Tophats/RingTophat';
import PKWebSocket from 'components/PKWebSocket/PKWebSocket';

import Zendesk from "react-zendesk";
import { ZendeskAPI } from "react-zendesk";

//import SelectVirtualized from 'react-select-virtualized';
import Select from 'react-select';

import { LinkedInPopUp } from 'react-linkedin-login-oauth2';
//import { AgoraChat } from 'components/VideoChat/AgoraChat';
//import AgoraChat from 'components/Agora/pages/App';
//import LinkedInPopUp from 'containers/SocialLogin/LinkedIn/LinkedInPopUp';

import UserContext from 'store/UserContext';

//import {asyncContainer, Typeahead, Menu as TypeaheadMenu, MenuItem as TypeaheadMenuItem} from 'react-bootstrap-typeahead';
import {withAsync, Typeahead, Menu as TypeaheadMenu, MenuItem as TypeaheadMenuItem} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

//const AsyncTypeahead = asyncContainer(Typeahead);
const AsyncTypeahead = withAsync(Typeahead);

const ZENDESK_KEY = "c0d94fa2-3bcd-4958-a7c4-a5dcf77c2594";

const main_darkmode_color = "#eeeeee";
const main_darkmode_background_color = "#18191A";
const secondary_darkmode_background_color = "#333333";



//let org_friendly_url = "";

//const UserContext = React.createContext({});

class Menu extends React.Component {
  static contextType = UserContext;
  
  constructor(props) {
    super(props);
    this.state = {
      //search_typeahead_active_index: -1,
      verification_modal_show: false,
      ring_info: null,
      unread_user_notifications_count: 0,
      user_notifications: [],
      searchInput: '',
      //search_autocomplete_value_array: [],
      search_autocomplete_loading: false,
      search_autocomplete_options: [],
      show_onboarding_modal: false,
      show_signup_modal: false,
      org_options: [],
      selected_org_option_index: 0,
      selected_org_option: null,
      tophat_info: {},
      tophat_display: false,
      otp: '',
      reloading: false,
      redirect_url: false,
      //required_container: true,
      verified: "Un Verified",
      showModal: false,
      accountOtpLoader: false,
      accountResendLoader: false,
      validatedOtp: false,
      InvalidMsg: 0,
      InvalidResendMsg: null,
      userName: '',
      //loading: true,
      loading: false,
      avatar_image_url: null,
      friendly_urlRes:null,
      //adminType:'',
      org_info: [],
      org_name: "",
      org_help_page_url: "",
      orgs_by_friendly_url: {},
      location_info: [], // for location_admin nav
      channel_info: [], // for channel_admin nav
      dynamic_logo: null
    };
    
    this.search_typeahead_active_index = -1;
    
    // try to see if user changed
    let user_info_obj = {
      user_entity_uuid,
      user_Status_Ver,
      user_access_level,
      user_account_level,
      owner_perms
    };
    this.user_identifier_string = JSON.stringify(user_info_obj);
    
    this.state.UserState = false;
    
    this.menuContainerFluid = false;
    
    /*
    this.state.required_container = true;
    let current_path = window.location.pathname;
    let without_container_pages = ["/linkedin", "/login", "/register", "/aboutyourself", "/sendresetpasswordemail", "/resetpassword"];
    if (without_container_pages.includes(current_path)) {
      this.state.required_container = false;
    }
    if (current_path.startsWith('/embed/')) {
      this.state.required_container = false;
    }
    */
    //this.routeChange = this.routeChange.bind(this);
    
    this.searchInput_ref = React.createRef(); // for clearing input
    
    
    //this.workspace_base_url = "";

    /*
      if (org_friendly_url) {
        this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        axios.defaults.headers.common['X-PK-Organization'] = org_friendly_url;
      } else {
        this.workspace_base_url = "";
        axios.defaults.headers.common['X-PK-Organization'] = '';
      }
    */
    
    //if (org_friendly_url) {
      //this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    //}

    console.log("Menu constructor",org_friendly_url);
    
    /*
    if (current_path.startsWith(local_routes.workspace+'/')) {
      // if attempting a workspace URL, make sure we are in correct workspace (URL matches the value in localStorage)
      let tmp_path_array = current_path.split('/');
      //console.log("Menu constructor - path test",org_friendly_url,tmp_path_array);
      if (!tmp_path_array[2] || tmp_path_array[2] !== org_friendly_url) {
        // does user belong to this workspace, but just is not in it atm?
        console.log("owner_perms",tmp_path_array[2],owner_perms);
        if (user_access_level === 'admin' || (owner_perms.organizations && owner_perms.organizations[tmp_path_array[2]])) {
          // user does belong to this org...switch app to correct workspace and then reload
          console.error("Auto-switching user into workspace:",tmp_path_array[2]);
          setLocalStorageSubVal("PersistentUserState",'org_friendly_url',tmp_path_array[2]);
          grabFromLocalStorage();
          //org_friendly_url = tmp_path_array[2];
          //this.state.loading = true;
          //this.state.reloading = true;
          //this.props.history.push(current_path);
          //window.location.reload(true);
          //this.onWorkspaceChange(tmp_path_array[2]);
        } else {
          // illegal request!
          console.error("Illegal Workspace request! Should match:",org_friendly_url);
          this.state.loading = true;
          this.state.reloading = true;
          this.props.history.push('/404');
        }
      }
    } else {
      // if attempting a public URL, make sure we are in public mode
      if (org_friendly_url !== "") {
        // in workspace, but making public request. switch user to public mode and then reload
        console.error("Auto-switching user into public view");
        setLocalStorageSubVal("PersistentUserState",'org_friendly_url',"");
        grabFromLocalStorage();
        //org_friendly_url = "";
        //this.state.loading = true;
        //this.state.reloading = true;
      }
    }
    */
    
    this.checkForWorkspaceChange();
    this.check_local_storage_change_interval = setInterval(() => this.checkForLocalStorageChange(), 2000); // 2s
    
    //this.checkOnboarding();
    this.check_onboarding_interval = setInterval(() => this.checkOnboarding(),86400000); // 24h
    
    this.notifications_interval_time = 30; // 30s
    
    setTimeout(() => {
      this.checkSignup();
    }, 2000);
    
    
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
      axios.defaults.headers.common['X-PK-Organization'] = org_friendly_url;
    } else {
      this.workspace_base_url = "";
      axios.defaults.headers.common['X-PK-Organization'] = '';
    }
    
    /*
    this.unlisten = this.props.history.listen((location, action) => {
      console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`)
      console.log(`The last navigation action was ${action}`)
    });
    */

    /*
    // if we are in workspace, make sure we are not trying to access certain pages in public mode
    if (org_friendly_url) {
      let workspace_url_buckets = {
        '/presentations': true,
        '/events': true,
        '/channels': true,
        '/searchresults': true,
        '/categories': true,
        '/pkcreation': true,
        '/pklist': true,
        '/myevents': true,
        '/users': true,
        '/managechannel': true,
        '/managechannelevent': true,
      };
      for (let workspace_url_bucket of Object.keys(workspace_url_buckets)) {
        if (current_path.startsWith(workspace_url_bucket)) {
          this.state.redirect_url = "/404"; 
        }
      }
    }
    */

    /*
    const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
    if (org_friendly_url) {
      //this.state.org_friendly_url = org_friendly_url;
      this.org_friendly_url = org_friendly_url;
    }
    */
    
    this.supported_language_abbreviations = new Set(['en-US','ja-JP']);
      //this.supported_language_abbreviations.add('en-US');
      //this.supported_language_abbreviations.add('ja-JP');

    window.addEventListener('beforeunload', this.onbeforeunload);
  }

  onbeforeunload = async (event) => {
    console.log("MENU onbeforeunload");
    //event.preventDefault();
    //alert("HEY");
    
    //let message = 'Are you sure you want to close?';
    //event.returnValue = message;
    
    //return message;
    //this.leaveSession();
    
    
    if (user_Status === 1 && user_entity_uuid) {
      // going offline...tell the database about it
      // but only if we are not in a chat
      if (!window.location.pathname.startsWith('/chats/')) {
        let patch_obj = {
          is_online: false
        };
        try {
          axios.patch(`${apiUrl}users/${user_entity_uuid}`,patch_obj);
        } catch (err) {
          // ignore
        }
      }
    }
    
  }

  componentWillUnmount() {
    console.log("MENU componentWillUnmount");
    clearInterval(this.check_local_storage_change_interval);
    clearInterval(this.check_onboarding_interval);
    clearInterval(this.check_for_notifications_interval);
    //this.unlisten();
    window.removeEventListener('beforeunload', this.onbeforeunload);
  }
  
  checkForNotifications = async () => {
    if (user_Status === 1) {
      console.log("Menu checkForNotifications");
      let user_notifications = await get_user_notifications();
      let unread_user_notifications = user_notifications.filter( element => {
        if (element.xref_data && element.xref_data.read_time) {
          return false;
        } else {
          return true;
        }
      });
      console.log(" user_notifications",unread_user_notifications.length,user_notifications);
      this.setState({
        user_notifications: [...user_notifications],
        unread_user_notifications_count: unread_user_notifications.length
      });
    }
  }
  
  checkSignup = async () => {
    console.log("Menu checkSignup",user_Status);
    if (user_Status !== 1 && window.location.pathname === '/') {
      window.localStorage.setItem('loginOrigin',this.props.location.pathname);
      this.setState({
        show_signup_modal: true
      });
    }
  }
  
  checkOnboarding = async () => {
    if (user_Status === 1 && this.context.user_info) {
      console.log("Menu checkOnboarding");
      if (
        !this.context.user_info.firstname ||
        !this.context.user_info.lastname ||
        !this.context.user_info.resident_locations ||
        this.context.user_info.resident_locations.length === 0 ||
        (!this.context.user_info.interest_category && this.context.user_info.created_time > (get_current_unix_stamp() - 86400)) 
      ) {
        this.setState({
          show_onboarding_modal: true
        });
      }
    }
  }
  
  checkForWorkspaceChange = async () => {
    console.log("Menu checkForWorkspaceChange",window.location.pathname);
    let current_path = window.location.pathname;
    if (current_path.startsWith(local_routes.workspace+'/')) {
      // if attempting a workspace URL, make sure we are in correct workspace (URL matches the value in localStorage)
      let tmp_path_array = current_path.split('/');
      //console.log("Menu constructor - path test",org_friendly_url,tmp_path_array);
      if (!tmp_path_array[2] || tmp_path_array[2] !== org_friendly_url) {
        // does user belong to this workspace, but just is not in it atm?
        console.log(" owner_perms",tmp_path_array[2],owner_perms);
        if (user_access_level === 'admin' || (owner_perms.organizations && owner_perms.organizations[tmp_path_array[2]])) {
          // user does belong to this org...switch app to correct workspace and then reload
          console.error(" Auto-switching user into workspace:",tmp_path_array[2]);
          setLocalStorageSubVal("PersistentUserState",'org_friendly_url',tmp_path_array[2]);
          grabFromLocalStorage();
        } else {
          // illegal request!
          console.error(" Illegal Workspace request! Should match:",org_friendly_url);
          //this.state.loading = true;
          //this.state.reloading = true;
          //setLocalStorageSubVal("PersistentUserState",'org_friendly_url',"");
          window.localStorage.setItem('loginOrigin',this.props.location.pathname);
          this.props.history.push('/accessrequired');
          return;
        }
      }
    } else {
      // if attempting a public URL, make sure we are in public mode
      if (org_friendly_url !== "") {
        // in workspace, but making public request. switch user to public mode and then reload
        console.error(" Auto-switching user into public view");
        setLocalStorageSubVal("PersistentUserState",'org_friendly_url',"");
        grabFromLocalStorage();
      }
    }
  }

  checkForLocalStorageChange = async () => {
    // check info in localStorage, see what changed
    let prev_org_friendly_url = org_friendly_url;

    let prev_user_info_obj = {
      user_entity_uuid,
      user_Status_Ver,
      user_access_level,
      user_account_level,
      owner_perms
    };
    let prev_user_identifier_string = JSON.stringify(prev_user_info_obj);
    
    grabFromLocalStorage();

    let new_user_info_obj = {
      user_entity_uuid,
      user_Status_Ver,
      user_access_level,
      user_account_level,
      owner_perms
    };
    let new_user_identifier_string = JSON.stringify(new_user_info_obj);

    if (prev_user_identifier_string !== new_user_identifier_string) {
      // reload!
      console.log("Menu checkForLocalStorageChange - user info changed, reload ("+prev_user_identifier_string+") -> ("+new_user_identifier_string+")");
      //this.state.loading = true;
      //this.state.reloading = true;
      //await this.APICalls();

      if (this.workspace_base_url) {
        //this.props.history.push("/");
        window.location.href = "/login";
      } else {
        window.location.reload(false);
      }
      //this.props.history.push("/");
      return;
    }    

    if (prev_org_friendly_url !== org_friendly_url) {
      let prev_workspace_base_url = this.workspace_base_url;
      console.log("Menu checkForLocalStorageChange ("+this.props.location.pathname+","+prev_workspace_base_url+") - org_friendly_url changed, reload ("+prev_org_friendly_url+") -> ("+org_friendly_url+")");
      //this.state.loading = true;
      //this.state.reloading = true;
      
      if (org_friendly_url) {
        // entering a workspace
        this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        axios.defaults.headers.common['X-PK-Organization'] = org_friendly_url;
        if (!this.props.location.pathname.startsWith(this.workspace_base_url)) {
          this.props.history.push(this.workspace_base_url);
        }
        //window.location.reload(false);
        this.APICalls();
        return;
      } else {
        // leaving a workspace
        this.workspace_base_url = "";
        axios.defaults.headers.common['X-PK-Organization'] = '';
        if (this.props.location.pathname.startsWith(prev_workspace_base_url)) {
          this.props.history.push("/");
        }
        //window.location.reload(false);
        this.APICalls();
        return;
      }
    }
    
    if (user_Status === 1) {
      if (user_access_token_expiration < Math.floor(new Date().getTime() / 1000)) {
        // token expired! Send to login screen
        
        //console.log("Menu checkForLocalStorageChange token expired! Send to login screen");
        //window.localStorage.clear();
        //this.props.history.push(local_routes.login);
        //window.location.reload(false);        
      }
    }
    
  }

  componentDidUpdate(prevProps) {
    console.log("Menu componentDidUpdate");
    this.checkForLocalStorageChange();
  }

  APICalls = async function () {
    console.log("Menu APICalls");
    
    let new_state = {...this.state};

    let user_info_promises = [];
    let tmp_api_promise_identifiers = [];

    user_info_promises.push(axios.get(`${apiUrl}managed_contents/public_site`));
    tmp_api_promise_identifiers.push("managed_contents");

    if (user_Status === 1) {
    
      if (!this.context.user_info.entity_uuid || this.context.user_info.last_get_user_info_time < (new Date().getTime() - 86400)) {
        user_info_promises.push(get_user_info());
        tmp_api_promise_identifiers.push("context_user_info");
      }
      
      // need to get user info
      //user_info_promises.push(axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Authorized));
      //tmp_api_promise_identifiers.push("user_info");
      user_info_promises.push(axios.get(`${user_API}/${user_entity_uuid}/locations?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_Authorized));
      tmp_api_promise_identifiers.push("user_info_resident_locations");
      user_info_promises.push(axios.get(`${user_API}/${user_entity_uuid}/categories.audience?filter_obj=${encodeURIComponent('{"favorited_time":{"gte":1}}')}`, myHeaders_Authorized));
      tmp_api_promise_identifiers.push("user_info_favorite_categories");
    
      // Here calling GET User API
      //user_info_promises.push(axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Authorized));
      //tmp_api_promise_identifiers.push("user_info");
      
      if (user_access_level === "admin") {
        // super_admin - get all orgs
        user_info_promises.push(axios.get(`${apiUrl}organizations`, myHeaders_Authorized));
        tmp_api_promise_identifiers.push("super_admin");
      } else {
        // other types of owners
        if (owner_perms.organizations && Object.keys(owner_perms.organizations).length > 0) {
          // get user's orgs
          user_info_promises.push(axios.get(`${user_API}/${user_entity_uuid}/organizations`, myHeaders_Authorized));
          tmp_api_promise_identifiers.push("org_user");
        }
        if (owner_perms.locations && Object.keys(owner_perms.locations).length > 0) {
          // get location_admin's locations
          user_info_promises.push(axios.get(`${user_API}/${user_entity_uuid}/locations?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`, myHeaders_Authorized));
          tmp_api_promise_identifiers.push("location_admin");
        } 
        if (owner_perms.channels && Object.keys(owner_perms.channels).length > 0) {
          // get channel_admin's channels
          user_info_promises.push(axios.get(`${user_API}/${user_entity_uuid}/channels?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`, myHeaders_Authorized));
          tmp_api_promise_identifiers.push("channel_admin");
        }
      }
      
      new_state.public_profile_flag = true;
      
    } else {
      // normal user
      new_state.org_name = "PechaKucha";
      new_state.dynamic_logo = this.context.theme === 'dark' ? dark_mode_logo : light_mode_logo;
      //this.setState(new_state);
      
      //new_state.show_signup_modal = true;
    }
    
    try {
      let api_responses = await Promise.all(user_info_promises);
      //console.log("Menu componentDidMount api_responses",JSON.stringify(api_responses,null,2));
      
      for (let i = 0; i < api_responses.length; i++) {
        if (tmp_api_promise_identifiers[i]) {
          if (tmp_api_promise_identifiers[i] === "managed_contents") {
            let response = api_responses[i];
            if (response.data.content_sections && response.data.content_sections['tophat_section_01']) {
              let tmp_tophat_info = response.data.content_sections['tophat_section_01'];
              if (tmp_tophat_info.introduction) {
                // hack for hex color, including #
                new_state.tophat_info['backgroundColor'] = tmp_tophat_info.introduction;
              }
              if (tmp_tophat_info.text_content && tmp_tophat_info.link_url && tmp_tophat_info.link_text) {
                if ('display_flag' in tmp_tophat_info && tmp_tophat_info.display_flag === false) {
                  new_state.tophat_display = false;
                } else {
                  new_state.tophat_display = true;
                }
              } else {
                new_state.tophat_display = false;
              }
              if (tmp_tophat_info.text_content) {
                new_state.tophat_info['text_content'] = tmp_tophat_info.text_content;
              }
              if (tmp_tophat_info.link_url) {
                new_state.tophat_info['link_url'] = tmp_tophat_info.link_url;
              }
              if (tmp_tophat_info.link_text) {
                new_state.tophat_info['link_text'] = tmp_tophat_info.link_text;
              }
            }
          } else if (tmp_api_promise_identifiers[i] === "context_user_info") {
            // set context from response
            this.context.setUserInfo(api_responses[i]);

            if (
              !this.context.user_info.firstname ||
              !this.context.user_info.lastname ||
              !this.context.user_info.resident_locations ||
              this.context.user_info.resident_locations.length === 0 ||
              (!this.context.user_info.interest_category && this.context.user_info.created_time > (get_current_unix_stamp() - 600)) 
            ) {
              new_state.show_onboarding_modal = true;
            }
            
            if (this.context.user_info.events.length > 0) {
              new_state.event_admin_flag = true; 
            }
            /*            
            let response = api_responses[i];
            
            let userName = response.data.lastname;
      
            if (response.data.firstname) {
              userName = response.data.firstname;
            }
            new_state.userName = userName;
      
            if (response.data.friendly_url !== null ) {
              new_state.friendly_urlRes = response.data.friendly_url;
              setLocalStorageSubVal("PersistentUserState",'user_friendly_url',response.data.friendly_url);
            }
            if (response.data.public_status && response.data.public_status !== 'public') {
              new_state.public_profile_flag = false;
            }
            if (response.data.avatar_image_url !== undefined && response.data.avatar_image_url !== null) {
              let url = response.data.avatar_image_url;
              let array = url.split("/");
              response.data.avatar_image_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`;
              new_state.avatar_image_url = response.data.avatar_image_url;
            }
            */
          } else if (tmp_api_promise_identifiers[i] === "super_admin" || tmp_api_promise_identifiers[i] === "org_user") {
            // super_admin/org_user org info
            let tmp_orgs = [];
            if (api_responses[i].data.entities) {
              tmp_orgs = api_responses[i].data.entities;
            } else {
              tmp_orgs = api_responses[i].data;
            }
            new_state.org_info = [];
            new_state.org_options = [{
              value: "public",
              label: "Public View",
              friendly_url: '/'
            }];
            new_state.selected_org_option_index = 0;
            new_state.selected_org_option = new_state.org_options[0];
            
            new_state.org_name = "";
            new_state.dynamic_logo = "";
            
            for (let tmp_org_obj of tmp_orgs) {
              new_state.orgs_by_friendly_url[tmp_org_obj.friendly_url] = tmp_org_obj;
              new_state.org_options.push({
                value: tmp_org_obj.entity_uuid,
                label: tmp_org_obj.entity_name+' View',
                friendly_url: tmp_org_obj.friendly_url
              });
              if (tmp_org_obj.friendly_url === org_friendly_url) {
                new_state.selected_org_option_index = new_state.org_options.length - 1;
                new_state.selected_org_option = new_state.org_options[new_state.org_options.length - 1];
                new_state.org_name = tmp_org_obj.entity_name;
                if (tmp_org_obj.help_page_url) {
                  new_state.help_page_url = tmp_org_obj.help_page_url;
                } 
                if (tmp_org_obj.image_url) {
                  new_state.dynamic_logo = tmp_org_obj.image_url;
                  new_state.org_account_level = tmp_org_obj.account_level;
                  let url = tmp_org_obj.image_url;
                  let array = url.split("/");
                  new_state.dynamic_logo=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padwhite_noborder_200x45/${array[5]}`;
                }
              } else {
                new_state.org_info.push(tmp_org_obj);
                //new_state.orgs_by_friendly_url[tmp_org_obj.friendly_url] = tmp_org_obj;
              }
            }
            if (org_name !== new_state.org_name) {
              this.changeWorkspace(org_friendly_url || '/',new_state.orgs_by_friendly_url);
            }

          } else if (tmp_api_promise_identifiers[i] === "location_admin") {
            new_state.location_info = api_responses[i].data;
          } else if (tmp_api_promise_identifiers[i] === "channel_admin") {
            new_state.channel_info = api_responses[i].data;
          }
        }
      }
      
      // set needed user info from context
      let userName = this.context.user_info.lastname;

      if (this.context.user_info.firstname) {
        userName = this.context.user_info.firstname;
      }
      new_state.userName = userName;

      if (this.context.user_info.friendly_url !== null ) {
        new_state.friendly_urlRes = this.context.user_info.friendly_url;
        setLocalStorageSubVal("PersistentUserState",'user_friendly_url',this.context.user_info.friendly_url);
      }
      if (this.context.user_info.public_status && this.context.user_info.public_status !== 'public') {
        new_state.public_profile_flag = false;
      }
      if (this.context.user_info.avatar_image_url !== undefined && this.context.user_info.avatar_image_url !== null) {
        let url = this.context.user_info.avatar_image_url;
        let array = url.split("/");
        //this.context.user_info.avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`;
        new_state.avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`;
      }
      
      if (!new_state.org_name) {
        // super_admin
        new_state.org_name = "PechaKucha";
        new_state.dynamic_logo = this.context.theme === 'dark' ? dark_mode_logo : light_mode_logo;
      }
      if (!new_state.dynamic_logo) {
        // if no org logo, use default PK logo
        new_state.dynamic_logo = this.context.theme === 'dark' ? dark_mode_logo : light_mode_logo;
      }
      
      //console.log("Menu componentDidMount new_state",JSON.stringify(new_state,null,2));
       
    } catch (err) {
      console.error("Menu APICalls ERROR",err);
      this.setState({ ModalLoader: false });
    }      
    
    new_state.loading = false;
    
    this.setState(new_state);
    
  }


  componentDidMount = async function () {
    //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
    console.log("Menu componentDidMount workspace_base_url: ",this.workspace_base_url);

    const language_abbreviation_raw = decodeURIComponent(getQueryString('lang'));
    // make last part uppercase
    if (language_abbreviation_raw && language_abbreviation_raw.indexOf('-') >= 0) {
      let [first_part,make_upper] = language_abbreviation_raw.split('-');
      let language_abbreviation = first_part+'-'+make_upper.toUpperCase();
      console.log(" language_abbreviation",language_abbreviation,this.supported_language_abbreviations.has(language_abbreviation));
      if (language_abbreviation && this.supported_language_abbreviations.has(language_abbreviation)) {
        console.log(" Setting language_abbreviation",language_abbreviation);
        this.context.setLanguage(language_abbreviation);
      }
    }
    
    await this.APICalls();
    await this.checkForNotifications();
    this.check_for_notifications_interval = setInterval(() => this.checkForNotifications(), (this.notifications_interval_time * 1000));
  }

  changeWorkspace = (tmp_org_friendly_url, tmp_orgs_by_friendly_url) => {
    console.log("Menu changeWorkspace",tmp_org_friendly_url,tmp_orgs_by_friendly_url);
    if (tmp_org_friendly_url !== '/') {
      setLocalStorageSubVal("PersistentUserState",'org_friendly_url',tmp_org_friendly_url);
      setLocalStorageSubVal("PersistentUserState",'org_account_level',tmp_orgs_by_friendly_url[tmp_org_friendly_url].account_level);
      setLocalStorageSubVal("PersistentUserState",'org_name',tmp_orgs_by_friendly_url[tmp_org_friendly_url].entity_name);
      setLocalStorageSubVal("PersistentUserState",'org_uuid',tmp_orgs_by_friendly_url[tmp_org_friendly_url].entity_uuid);
      //this.props.history.push(local_routes.workspace+"/"+tmp_org_friendly_url);
    } else {
      setLocalStorageSubVal("PersistentUserState",'org_friendly_url','');
      setLocalStorageSubVal("PersistentUserState",'org_account_level','');
      setLocalStorageSubVal("PersistentUserState",'org_name','');
      setLocalStorageSubVal("PersistentUserState",'org_uuid','');
      //this.props.history.push("/");
    }
    
  }

  onDropdownWorkspaceChange = selectedWorkspace => {
    if (!selectedWorkspace) {
      return;
    }
    console.log("onDropdownWorkspaceChange",selectedWorkspace);
    this.setState({
      selected_org_option: selectedWorkspace
    });
    this.changeWorkspace(selectedWorkspace.friendly_url,this.state.orgs_by_friendly_url);
    this.checkForLocalStorageChange();
    
    //window.location.reload(false);
    //this.props.history.push(local_routes.workspace+"/"+this.workspace_base_url);
  }

  onWorkspaceChange = (tmp_org_friendly_url) => {
    this.changeWorkspace(tmp_org_friendly_url,this.state.orgs_by_friendly_url);
  }

  /*
  // Modal functionality starts here
  close = () => {
    this.setState({ showModal: false });
  }
  open = () => {
    this.setState({ showModal: true });
  }
  */
  
  /*
  // Email Verify
  myOtpChangeHandler = event => {
    console.log("myOtpChangeHandler",event.target.id,event.target.value);
    if (event.target.id === "otpName") {
      this.setState({ otp: event.target.value });
    }
  }
  */
  
  /*
  getSetUpdatedUserData = async () => {
      // Here calling GET User API
      let user_response = await axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
          
      let apiRes = user_response.data;
      let user_data = getKey("UserData");
      let updated_user_data = {
        UserMail: null,
        login_Auth_Res: {
          access_token: user_data.login_Auth_Res.access_token,
          expTime: user_data.login_Auth_Res.expTime,
          user_uuid: user_data.login_Auth_Res.user_uuid,
          access_level: apiRes.access_level,
          account_level: apiRes.account_level || 'normal',
          status_code: apiRes.status_code
        }
      };
      saveKey("UserData", JSON.stringify(updated_user_data));    
  }
  
  // Email Verify Submit
  handleSubmitOtpData = async () => {
    
    console.log("Trying to submit otp",this.state.otp);
    if (this.state.otp.length < 6 || this.state.otp.length > 6) {
      console.log("OTP bad length!",this.state.otp.length);
      this.setState({ InvalidMsg: 3 })
      return;
    }
    this.setState({ accountOtpLoader: true, InvalidMsg: 0 })
    let otpData = { "verification_token": this.state.otp }
    try {
      let verify_response = await axios.post(`${user_API}/${user_entity_uuid}/verifyEmail`, JSON.stringify(otpData), myHeaders_Authorized)
      // success
      this.setState({ accountOtpLoader: false, InvalidMsg: 1 })
    
      saveKey("UserData", JSON.stringify({login_Auth_Res: verify_response.data}));
      
      this.setState({
        //userName,
        loading: true,
        reloading: true,
        validatedOtp: true,
        accountOtpLoader: false,
        InvalidMsg: 1
      });
      
    } catch (err) {
      if (err['status'] === 403 && err.data && err.data.message && err.data.message.startsWith('user not in unverified state')) {
        console.log("User already verified!");
        this.setState({ accountOtpLoader: false, InvalidMsg: 1 })
        await this.getSetUpdatedUserData();
        this.setState({
          //userName,
          loading: true,
          reloading: true,
          validatedOtp: true,
          accountOtpLoader: false,
          InvalidMsg: 1
        });
        return;
      } else {
        this.setState({ accountOtpLoader: false, InvalidMsg: 2 })
        return;
      }
    }
  };
  
  // invalid messages for otp
  messageOtp = () => {
    const { InvalidMsg } = this.state;
    return (
      <div style={{ display: this.state.InvalidMsg === 0 ? "none" : null }} className="Invalid-section resend-msg">
        {
          InvalidMsg === 1 ?
            <span className="Valid-Msg">Verified Successfully</span>
            :
            InvalidMsg === 2 ?
              <span className="Invalid-Msg">Invalid Verification Code! Please double check the code and try again</span>
              :
              InvalidMsg === 3 ?
              <span className="Invalid-Msg">Please enter exactly 6 digits</span>
              : null
        }
      </div>
    )
  }
  
  // OTP Resend Api starts here
  handleSubmitOtpResendData = async () => {
    this.setState({ accountResendLoader: true })
    let resendBody = {}
    this.setState({ InvalidResendMsg: null });
    try {
      await axios.post(`${user_API}/${user_entity_uuid}/resendVerificationEmail`, resendBody, myHeaders_Authorized);
      this.setState({ accountResendLoader: false, InvalidResendMsg: 'Verification code successfully sent' });
    } catch (err) {
      console.log("ERROR",err);
      if (err['status'] === 429) {
        this.setState({ accountResendLoader: false, InvalidResendMsg: 'Verification email recently sent; please wait some time before trying again' });
      } else if (err['status'] === 403 && err.data && err.data.message && err.data.message.startsWith('User has already verified their email')) {
        console.log("User already verified!");
        await this.getSetUpdatedUserData();
        this.setState({
          //userName,
          loading: true,
          reloading: true,
          validatedOtp: true,
          accountOtpLoader: false,
          InvalidMsg: 1
        });        
        //this.setState({ accountResendLoader: false, InvalidResendMsg: 'Email already verified! Please logout and re-login and enjoy PechaKucha.com!' });
      } else {
        // should normally never happen
        this.setState({ accountResendLoader: false, InvalidResendMsg: 'ERROR: '+err.response.data.message });        
      }
    }
  };
  
  messageResend = () => {
    const { InvalidResendMsg } = this.state;
    return (
      <div style={{ display: !this.state.InvalidResendMsg ? "none" : null }} className="Invalid-section resend-msg">
        {InvalidResendMsg}
      </div>
    )
  }
  
  // OTP Resend Api Ends here
  // input maximum length
  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }
  */
  
  // Modal functionality ends here
  loginState = () => {
    window.localStorage.setItem('loginOrigin',this.props.location.pathname);
    this.props.history.push("/login");
    //window.location.href = `${origin}/login`;
  };
  
  logoutState = async () => {
    if (user_Status === 1) {
      //window.localStorage.clear();
      
      let patch_obj = {
        is_online: false
      };
      try {
        await axios.patch(`${apiUrl}users/${user_entity_uuid}`,patch_obj);
      } catch (err) {
        // ignore
      }
      
      window.localStorage.setItem('UserData',null);
      window.localStorage.setItem('PersistentUserState',null);
      this.context.setUserInfo({});
      //this.props.history.push("/login");
      //window.location.href = "/login";
    }
  }
  
  
  onSearchPress = async ({ key = '' }) => {
    // JBB 7/5/2021 - trying to make this work if user presses enter while type-ahead query is running
    if ((key === 'Enter' || key === 'Tab') && this.state.searchInput.length >= 3) {
      //console.log("onSearchPress",key,this.state.search_autocomplete_loading,this.state.searchInput,this.state.search_autocomplete_options,this.search_typeahead_active_index);
      if (!this.state.search_autocomplete_options[0] || this.state.search_autocomplete_options[0].label !== this.state.searchInput || this.search_typeahead_active_index === -1) {
        //console.log("SEARCH NOW!!!");
        // since we are manually calling handleTyleHeadChange, we need to clear the typeahead component manually
        //this.searchInput_ref.current.getInstance().clear();
        //this.searchInput_ref.current.clear();
        let search_options = [{
          label: this.state.searchInput,
          id: 'customSearchInput'
        }];
        this.handleTypeHeadChange(search_options);
      }
    }
  }

  onBoardingModalChangesSaved = (user_info) => {
    this.context.setUserInfo(user_info);
  }

  // Typeahead does not support async/await
  handleTypeHeadSearch = async (query) => {
    //return;
    console.log("Menu handleTypeHeadSearch",query,this.state.searchInput);

    let searchInputObj = {
      //label: this.state.searchInput,
      label: query,
      id: 'customSearchInput'
    }
    
    this.setState({
      //[loaderKey]: true,
      search_autocomplete_loading: true,
      //search_autocomplete_options: [searchInputObj]
    });
    
    let params = {
      q: query,
      format: 'objects'
    }

    
    try {
      let autocomplete_response = await axios.get(`${searchUrl}sitesearch_autocomplete`, { params });
      let data = autocomplete_response.data;
        data.forEach( (element,index,result_array) => {
          if (element.entity_name) {
            element.label = element.entity_name;
            element.id = element.entity_uuid;
          }
          // see if we got an exact match - put it at the top if we do
          if (element.entity_name.toLowerCase() === query) {
            result_array.splice(index,1);
            result_array.unshift(element);
          }
        });
        
        data.unshift(searchInputObj);
        //console.log("handleTypeHeadSearch",data);
        this.setState({
          search_autocomplete_options: data,
          //[loaderKey]: false
          search_autocomplete_loading: false
        });

    } catch (err) {
      this.setState({
        //[loaderKey]: false,
        search_autocomplete_loading: false,
        search_autocomplete_options: []
      });
    }

    /*
    //axios.get(`${searchUrl}sitesearch_autocomplete?q=${query}&format=objects`)
    axios.get(`${searchUrl}sitesearch_autocomplete`, { params })
      .then(({data = []}) => {
        
        data.forEach( (element,index,result_array) => {
          if (element.entity_name) {
            element.label = element.entity_name;
            element.id = element.entity_uuid;
          }
          // see if we got an exact match - put it at the top if we do
          if (element.entity_name.toLowerCase() === this.state.searchInput.toLowerCase()) {
            result_array.splice(index,1);
            result_array.unshift(element);
          }
        });
        
        data.unshift(searchInputObj);
        //console.log("handleTypeHeadSearch",data);
        this.setState({
          search_autocomplete_options: data,
          [loaderKey]: false
        });
      })
      .catch(() => this.setState({
        [loaderKey]: false,
        search_autocomplete_options: []
      }));
    */
  }
  
  
  onSearchInputChange = (searchInput) => {
    //console.log("onSearchInputChange",searchInput);
    this.setState({
      searchInput
      //search_autocomplete_value_array: [searchInput]
    });
  }
  

  renderMenu = (results, menuProps) => {
        //console.log("renderMenu",results, menuProps);
        /*
        let customOption = results.find(r=> r.customOption);
        let indexOfCustomOption = results.findIndex(r=> r.customOption);
        if (customOption) {
            results.splice(indexOfCustomOption,1);
            results.unshift(customOption);
        }
        */
        
        return <TypeaheadMenu {...menuProps}>
            {
                results.map((result, index) => {
                  if (!result) {
                    return;
                  }
 
                  if (result.entity_uuid) {
                    let direct_to_page_text = 'Go!';
                    if (result.entity_type === 'users') {
                      direct_to_page_text = 'Profile';
                    } else if (result.entity_type === 'presentations') {
                      direct_to_page_text = 'Presentation';
                    } else if (result.entity_type === 'events') {
                      direct_to_page_text = 'Event';
                    } else if (result.entity_type === 'locations') {
                      direct_to_page_text = 'City';
                    } else if (result.entity_type === 'categories') {
                      direct_to_page_text = 'Category';
                    } else if (result.entity_type === 'channels') {
                      direct_to_page_text = 'Channel';
                    }
                    return <TypeaheadMenuItem key={result.id} option={result} position={index}>
                        {result.entity_name} - <span style={{ fontSize: "smaller", fontWeight: "bold" }}>{direct_to_page_text}</span>
                        </TypeaheadMenuItem>
                    
                  } else {
                    //console.log(" allowNew object",result);
                    return <TypeaheadMenuItem key={result.id} option={result} position={index}>
                        {/*{result.label} - <span style={{ fontSize: "smaller", fontWeight: "bold" }}>Search</span>*/}
                        {result.label} - <span style={{ fontSize: "smaller", fontWeight: "bold" }}>Search</span>
                        </TypeaheadMenuItem>
                  }
                  
            })}
        </TypeaheadMenu>
    }
  
  handleTypeHeadChange = async (selectedOptions) => {
    console.log("menu handleTypeHeadChange",selectedOptions);
    
    if (selectedOptions.length === 0) {
      return;
    }

    let searchQuery;
    if (selectedOptions[0].entity_uuid && selectedOptions[0].friendly_url) {
      // go directly to the page!
      this.searchInput_ref.current.clear();
      this.setState({
        //search_autocomplete_value_array: [],
        //search_autocomplete_options: [],
        searchInput: ''
      });
      let redirect_url = `${this.workspace_base_url}${local_routes[selectedOptions[0].entity_type]}/${selectedOptions[0].friendly_url}`;
      this.props.history.push(redirect_url);
      return;
      
      /*
      let entity_response = await axios.get(`${apiUrl}${selectedOptions[0].entity_type}/${selectedOptions[0].entity_uuid}?attributes_array=${encodeURIComponent('["friendly_url","status_code"]')}`);
      if (entity_response.data.status_code === 1 && entity_response.data.friendly_url) {
        let redirect_url = `${this.workspace_base_url}${local_routes[selectedOptions[0].entity_type]}/${entity_response.data.friendly_url}`;
        this.props.history.push(redirect_url);
        this.setState({
          //search_autocomplete_value_array: [],
          search_autocomplete_options: [],
          //searchInput: ''
        });
        return;
      } else {
        searchQuery = selectedOptions[0].entity_name;
      }
      */
    } else {
      searchQuery = selectedOptions[0].label;
      //searchQuery = searchQuery.replace('#','');
    }
    
    
    //this.searchInput.current.value = '';
    this.searchInput_ref.current.clear();
    this.setState({
      //search_autocomplete_value_array: [],
      //search_autocomplete_options: [],
      searchInput: ''
    });

    let search_url = `${this.workspace_base_url}/searchresults?searchQuery=${encodeURIComponent(searchQuery)}`;
    this.props.history.push(search_url);

    
  }
  
  notificationsRead = async (e) => {
    console.log("notificationsRead", e);
    // patch notifications that were read
    let patch_promises = [];
    let tmp_user_notifications = [...this.state.user_notifications];
    for (let notification_obj of tmp_user_notifications) {
      let current_unix_stamp = get_current_unix_stamp();
      let patch_obj = {
        read_time: current_unix_stamp
      };
      patch_promises.push(axios.patch(`${apiUrl}users/${this.context.user_info.entity_uuid}/notifications/${notification_obj.entity_uuid}`,patch_obj));
      notification_obj.xref_data = {
        read_time: current_unix_stamp
      };
    }
    await Promise.all(patch_promises);
    this.setState({
      user_notifications: tmp_user_notifications,
      unread_user_notifications_count: 0
    });
  }

  OnUpdateUserContext = async (updated_user_info) => {
    console.log("OnUpdateUserContext",updated_user_info);
    //let tmp_user_info = {...this.context.user_info};
    if (updated_user_info.chats && updated_user_info.chats[0]) {
      // re-pull chat data via API
      let tmp_user_info = await get_user_info(false,'user_info_chat',this.context.user_info,updated_user_info.chats[0]);
      //console.log('UPDATED USER_INFO',tmp_user_info);
      this.context.setUserInfo(tmp_user_info);
    }
    if (updated_user_info.friends && updated_user_info.friends[0]) {
      // re-pull friend data via API
      let tmp_user_info = await get_user_info(false,'user_info_friend',this.context.user_info,updated_user_info.friends[0]);
      //console.log('UPDATED USER_INFO',tmp_user_info);
      this.context.setUserInfo(tmp_user_info);
    }
    if (updated_user_info.admins && updated_user_info.admins[0]) {
      // re-pull friend data via API
      let tmp_user_info = await get_user_info(false,'user_info_admin',this.context.user_info,updated_user_info.admins[0]);
      //console.log('UPDATED USER_INFO',tmp_user_info);
      this.context.setUserInfo(tmp_user_info);
    }
    if (updated_user_info.friends_admins && updated_user_info.friends_admins[0]) {
      // re-pull friend data via API
      let tmp_user_info = await get_user_info(false,'user_info_friend_admin',this.context.user_info,updated_user_info.friends_admins[0]);
      //console.log('UPDATED USER_INFO',tmp_user_info);
      this.context.setUserInfo(tmp_user_info);
    }
    if (updated_user_info.unfriends && updated_user_info.unfriends[0]) {
      // re-pull friend data via API
      let tmp_user_info = await get_user_info(false,'user_info_unfriend',this.context.user_info,updated_user_info.unfriends[0]);
      //console.log('UPDATED USER_INFO',tmp_user_info);
      this.context.setUserInfo(tmp_user_info);
    }
  }

  OnRing = async (ring_info) => {
    console.log("OnRing",ring_info);
    
    // re-pull chat data via API
    let tmp_user_info = await get_user_info(false,'user_info_chats',this.context.user_info);
    this.context.setUserInfo(tmp_user_info);

    this.setState({
      ring_info: ring_info
    });
    
    // now set interval to stop ringing
    this.ring_timeout = setTimeout(() => {
      this.setState({
        ring_info: null
      })
    }, 30000);
  }
  
  joinCall = async (chat_info) => {
    // open new tab for the actual chat
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    window.open('/chats/'+chat_info.friendly_url, 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
  }
  
  OnAnswerRing = async (chat_info) => {
    console.log("OnAnswerRing",chat_info);
    clearTimeout(this.ring_timeout);
    this.setState({
      ring_info: null
    });
    await this.joinCall(chat_info);
  }
  
  OnDismissRing = async (chat_info) => {
    console.log("OnDismissRing",chat_info);
    clearTimeout(this.ring_timeout);
    this.setState({
      ring_info: null
    });
  }

  render() {
    window.prerenderReady = false;
    const { accountOtpLoader, loading, accountResendLoader, userName, avatar_image_url } = this.state;
    //console.log("adminType",this.state.adminType)
    
    let pk_create_local_route = local_routes.pkcreatehome;

    if (user_Status === 1) {
      pk_create_local_route = local_routes.pkcreation;
    }
    
    if (loading) {
      return (
        <FullPageSpinner />
      );
    }
    
    if (this.state.redirect_url) {
      return (
        <Redirect to={this.state.redirect_url} />
      );
    }

    let required_container = true;
    let current_path = window.location.pathname;
    let without_container_pages = [
      "/linkedin",
      "/login",
      "/register",
      "/aboutyourself",
      "/sendresetpasswordemail",
      "/resetpassword",
      //"/runofshowplay",
      //"/chats/",
      //"/videochat"
    ];
    if (without_container_pages.includes(current_path)) {
      required_container = false;
    }
    
    if (current_path.startsWith('/embed/') || current_path.startsWith('/agora_chats/') || current_path.startsWith('/chats/') || current_path.includes('/runofshowplay/')) {
      required_container = false;
    }
    
    //const { theme } = this.context.theme;
    
    let bg = "body {background-color: #fff; color: #000;}";
    let txt_color = "#000";
    let background_color = "#fff";
    let secondary_background_color = "#fff";
    let logo = this.state.dynamic_logo;
    
    if (this.context.theme === "dark") {
      bg = "body {background-color: "+main_darkmode_background_color+"; color: "+main_darkmode_color+";}";
      txt_color = main_darkmode_color;
      background_color = main_darkmode_background_color;
      secondary_background_color = secondary_darkmode_background_color;
      if (!this.workspace_base_url) {
        logo = dark_mode_logo;
      }
    } else {
      if (!this.workspace_base_url) {
        logo = light_mode_logo;
      }
    }
    //let bg = (this.context.theme === "dark" ? "body {background-color: #18191A; color: #eeeeee;}" : "body {background-color: #fff; color: #000;}");
    //console.log("MENU context.user_info.theme, bg",this.context.theme, bg);
    //let bg = "body {background-color: #404042; color: gray;}";

      return (
        <React.Fragment>
          <Helmet defer={false}>
            <style>{bg}</style>
          </Helmet>
          {required_container === true ? (
            <div>
              
              { (!this.workspace_base_url && this.state.tophat_display) &&
              <div className="sub-nav">
                <div className={`sub-menu-nav sub-menu-nav-${this.context.theme} tophat`} style={{ backgroundColor: this.state.tophat_info['backgroundColor'] || "#E50114" }}>
                  <Container fluid={this.menuContainerFluid}>
                  {/*<div className="container">*/}
                    {this.state.tophat_info.text_content}
                    { this.state.tophat_info.link_url.startsWith('https://') ?
                      <a target="_blank" style={{ textDecoration: "underline", color: "white" }} href={this.state.tophat_info.link_url}>{this.state.tophat_info.link_text}</a>
                      :
                      <Link style={{ textDecoration: "underline", color: "white" }} to={this.state.tophat_info.link_url}>{this.state.tophat_info.link_text}</Link>
                    }
                  </Container>
                </div>
              </div>
              }
              
              
              {/* Top bar starts here */}
              <header className={`${this.context.theme} menu-header-${this.context.theme}`}>
                {
                  user_Status === 1 ?
                    <React.Fragment>
                      { this.context.user_info.entity_uuid &&
                        <React.Fragment>
                          <OnboardingModal
                            show={this.state.show_onboarding_modal}
                            onHide={() => this.setState({show_onboarding_modal:false})}
                          >
                          </OnboardingModal>
                          <RingTophat
                            ring_info={this.state.ring_info}
                            OnAnswerRing={this.OnAnswerRing}
                            OnDismissRing={this.OnDismissRing}
                          />
                          <PKWebSocket
                            user_uuid={user_entity_uuid}
                            user_token={user_access_token}
                            OnRing={this.OnRing}
                            OnUpdateUserContext={this.OnUpdateUserContext}
                          />
                      </React.Fragment>
                      }                      

                      {user_Status_Ver !== "1" &&
                        <div className="userEmailVerify">
                          <div className="emailVerify">
                            <p>Hi{userName ? ' '+userName : ''}! Please verify your email and start enjoying PechaKucha!</p>
                            <button theme="btn-global btn-hover btn-green btn-fit"
                              onClick={() => this.setState({ verification_modal_show: true})}>Verify Email</button>
                            <div className="emailVerifyContainer">
                                <VerificationModal
                                    show={this.state.verification_modal_show}
                                    onHide={() => this.setState({ verification_modal_show: false})}
                                />
                            </div>
                          </div>
                        </div>
                      }
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <SignupModal
                          show={this.state.show_signup_modal}
                          onHide={() => this.setState({show_signup_modal:false})}
                        >
                        </SignupModal>
                    </React.Fragment>
                }
                <Container fluid={this.menuContainerFluid}>
                {/*<div className="container">*/}
                  {/* START navbar */}
                  <Navbar
                    //sticky="top"
                    //fixed="top"
                    //expanded={true}
                    collapseOnSelect={true}
                    expand="lg"
                    //variant="dark"
                    //bg={this.context.theme}
                    variant={this.context.theme}
                    className="Navbar"
                  >
                    
                    <Navbar.Brand as={NavLink} to={this.workspace_base_url ? this.workspace_base_url : '/'}>
                      {this.state.dynamic_logo &&
                      <img
                        //src={this.state.dynamic_logo}
                        src={logo}
                        alt="Pecha Kucha Presentations"
                        className="img-fluid navbar-brand"
                      />
                      }
                    </Navbar.Brand>

                      <div className="search-nav" >
                        <i className="fa fa-search nav-search"></i>
                        
                        <AsyncTypeahead
                          //variant={this.context.theme}
                          //className={this.context.theme}
                          //style={{ backgroundColor: "#333333" }}
                          filterBy={(option, props) => { return true; }}
                          renderMenu={this.renderMenu}

                          //labelKey="entity_name"

                          delay={300}

                          //filterBy={["entity_name"]}

                          clearButton={true}
                          
                          ref={this.searchInput_ref}

                          //allowNew={true}
                          
                          //selectHintOnEnter={true}
                          
                          id="typeahead1"

                          //selected={this.state.search_autocomplete_value_array}
                          //selected={[]} // this clears things out whenever onChange runs

                          isLoading={this.state.search_autocomplete_loading}
                          
                          //useCache={false}

                          placeholder={`Search ${this.state.org_name}...`}
                          minLength={3}

                          onChange={this.handleTypeHeadChange}
                          //onSearch={(query) => this.handleTypeHeadSearch('search_autocomplete_loading',query)}
                          onSearch={this.handleTypeHeadSearch}
                          options={this.state.search_autocomplete_options}

                          onKeyDown={this.onSearchPress} // check for enter in case it gets pressed while loading
                          onInputChange={this.onSearchInputChange}
                        >
                        {({activeIndex}) => {
                          // Passing a child render function to the component exposes partial
                          // internal state, including the index of the highlighted menu item.
                          this.search_typeahead_active_index = activeIndex;
                          //this.setState({search_typeahead_active_index: activeIndex});
                        }}
                        </AsyncTypeahead>
                        
                      </div>

                    { (user_Status === 1 && this.state.user_notifications.length > 0) &&
                      <Dropdown onClick={this.notificationsRead} className="notifications-dropdown collapsed">
                        <Dropdown.Toggle id="dropdown-basic">
                          <NotificationBadge count={this.state.unread_user_notifications_count} effect={[null, null, null, null]}/>
                          <i className="fa fa-bell" aria-hidden="true"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {
                            this.state.user_notifications.map((notification_obj,index) => {
                              if (index === this.state.user_notifications.length - 1) {
                                return (  
                                  <React.Fragment key={notification_obj.entity_uuid}>
                                    <Dropdown.Item as={Link} to={`${notification_obj.notification_resolution_url}`}>
                                      {notification_obj.notification_text}<br/>
                                      <span style={{ fontSize: 'smaller', fontWeight: 'normal' }}>{getRelativeTime(notification_obj.created_time)}</span>
                                    </Dropdown.Item>
                                  </React.Fragment>
                                );
                              } else {
                                return (  
                                  <React.Fragment key={notification_obj.entity_uuid}>
                                    <Dropdown.Item as={Link} to={`${notification_obj.notification_resolution_url}`}>
                                      {notification_obj.notification_text}<br/>
                                      <span style={{ fontSize: 'smaller', fontWeight: 'normal' }}>{getRelativeTime(notification_obj.created_time)}</span>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                  </React.Fragment>
                                );
                              }
                            })
                          }
                          
                        </Dropdown.Menu>
                      </Dropdown>
                    }                    

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    
                    <Navbar.Collapse id="responsive-navbar-nav">

                      <Nav className={`NavCustom`}>

                        { !this.workspace_base_url &&
                          <React.Fragment>
                            
                            <a className="nav-link" target="_blank" rel="noopener" href={local_routes.hostanevent}>
                              Host an Event
                            </a>
                            
                            {/*
                            <a className="nav-link" target="_blank" rel="noopener" href={local_routes.forschools}>
                              For Schools
                            </a>
                            <a className="nav-link" target="_blank" rel="noopener" href={local_routes.forbusiness}>
                              For Business
                            </a>
                            <a className="nav-link" target="_blank" rel="noopener" href={local_routes.usecases}>
                              Use Cases
                            </a>
                            */}
                            {/*
                            <a className="nav-link" target="_blank" rel="noopener" href={local_routes.pricing}>
                              Pricing
                            </a>
                            */}
                            
                            <Link className="nav-link" to={local_routes.pricing}>
                              Pricing
                            </Link>
                            
                          </React.Fragment>
                        }
                        { user_Status === 0 &&
                          <Nav.Link className="nav-link" onClick={this.loginState}>
                          Login
                          </Nav.Link>
                        }
                        { user_Status === 1 &&
                          <div className='profileResData'>
                            <Nav.Link className="nav-link" as={NavLink} to={this.workspace_base_url+local_routes.accountsettings}>
                              Account Settings
                            </Nav.Link>
                            {
                              !this.workspace_base_url &&
                                <React.Fragment>
                                {
                                  user_Status_Ver && user_Status_Ver === "1" && this.state.friendly_urlRes && this.state.public_profile_flag &&
                                    <Nav.Link className="nav-link" as={NavLink} to={`${local_routes.users}/${this.state.friendly_urlRes}`}>
                                      Profile{!this.state.public_profile_flag && <span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> PRIVATE</span>}
                                    </Nav.Link>
                                }
                                <Nav.Link className="nav-link" as={NavLink} to={local_routes.pklist}>
                                  My Presentations
                                </Nav.Link>
                                {
                                  (this.state.event_admin_flag || user_access_level === 'admin' || user_access_level === 'channel_admin' || user_access_level === 'location_admin') &&
                                  <Nav.Link className="nav-link" as={NavLink} to={local_routes.myevents}>
                                    My Events
                                  </Nav.Link>
                                }
                              </React.Fragment>
                            }
                            {
                              this.workspace_base_url &&
                              <React.Fragment>
                              {
                                user_Status_Ver && user_Status_Ver === "1" && this.state.friendly_urlRes &&
                                  <Nav.Link className="nav-link" as={NavLink} to={`${this.workspace_base_url}/users/${this.state.friendly_urlRes}`}>
                                    {this.state.org_name} Profile
                                  </Nav.Link>
                              }

                              <Nav.Link className="nav-link" as={NavLink} to={`${this.workspace_base_url}${local_routes.pklist}`}>
                                {this.state.org_name} My Presentations
                              </Nav.Link>
                              {
                                (user_access_level === 'admin' || organization_user_access_level === 'admin') &&
                                <Nav.Link className="nav-link" as={NavLink} to={`${this.workspace_base_url}${local_routes.myevents}`}>
                                  {this.state.org_name} My Events
                                </Nav.Link>
                              }

                              </React.Fragment>
                            }                           


                            <Nav.Link className="nav-link" onClick={this.logoutState}>
                               Logout
                            </Nav.Link>
                          </div>
                        }
                      </Nav>

                    </Navbar.Collapse>

                    

                    { (user_Status === 1 && this.state.user_notifications.length > 0) &&
                      <Dropdown onClick={this.notificationsRead} className="notifications-dropdown not-collapsed">
                        <Dropdown.Toggle id="dropdown-basic">
                          <NotificationBadge count={this.state.unread_user_notifications_count} effect={[null, null, null, null]}/>
                          <i className="fa fa-bell" aria-hidden="true"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {
                            this.state.user_notifications.map((notification_obj,index) => {
                              if (index === this.state.user_notifications.length - 1) {
                                return (  
                                  <React.Fragment key={notification_obj.entity_uuid}>
                                    <Dropdown.Item as={Link} to={`${notification_obj.notification_resolution_url}`}>
                                      {notification_obj.notification_text}<br/>
                                      <span style={{ fontSize: 'smaller', fontWeight: 'normal' }}>{getRelativeTime(notification_obj.created_time)}</span>
                                    </Dropdown.Item>
                                  </React.Fragment>
                                );
                              } else {
                                return (  
                                  <React.Fragment key={notification_obj.entity_uuid}>
                                    <Dropdown.Item as={Link} to={`${notification_obj.notification_resolution_url}`}>
                                      {notification_obj.notification_text}<br/>
                                      <span style={{ fontSize: 'smaller', fontWeight: 'normal' }}>{getRelativeTime(notification_obj.created_time)}</span>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                  </React.Fragment>
                                );
                              }
                            })
                          }
                          
                        </Dropdown.Menu>
                      </Dropdown>
                    }                    
                    

                  

                    
                    
                    {
                      user_Status === 1 &&
                      <Dropdown className="profile-dropdown">
                        <Dropdown.Toggle id="dropdown-basic">
                          <img src={avatar_image_url=== null ? avatar : avatar_image_url} className="img-fluid" alt="img" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          
                          <Dropdown.Item as={NavLink} to={this.workspace_base_url+local_routes.accountsettings}>Account Settings</Dropdown.Item>
                          <Dropdown.Divider />
                          {
                            this.workspace_base_url &&
                            <React.Fragment>
                              {
                                user_Status_Ver && user_Status_Ver === "1" && this.state.friendly_urlRes && this.state.public_profile_flag &&     
                                <React.Fragment>
                                  <Dropdown.Item as={NavLink} to={`${this.workspace_base_url}${local_routes.users}/${this.state.friendly_urlRes}`}>
                                    {this.state.org_name}<br/>
                                    Profile
                                  </Dropdown.Item>
                                  <Dropdown.Divider />
                                </React.Fragment>
                              }
                              <Dropdown.Item as={NavLink} to={`${this.workspace_base_url}${local_routes.pklist}`}>
                                {this.state.org_name}<br/>
                                My Presentations
                              </Dropdown.Item>
                              <Dropdown.Divider />

                              {
                                (user_access_level === 'admin' || organization_user_access_level === 'admin') &&
                                <React.Fragment>
                                  <Dropdown.Item as={NavLink} to={`${this.workspace_base_url}${local_routes.myevents}`}>
                                    {this.state.org_name}<br/>
                                    My Events
                                  </Dropdown.Item>
                                  <Dropdown.Divider />
                                </React.Fragment>
                              }

                              {/*
                              <Dropdown.Item href='/' eventKey='/' onSelect={this.onWorkspaceChange}>
                                Switch to Public View
                              </Dropdown.Item>
                              */}
                              <Dropdown.Divider />

                            </React.Fragment>
                          }
                          
                          {
                            !this.workspace_base_url &&
                            <React.Fragment>
                              {
                                (user_Status_Ver && user_Status_Ver === '1' && this.state.friendly_urlRes) &&     
                                <React.Fragment>
                                  <Dropdown.Item as={NavLink} to={`${this.workspace_base_url}${local_routes.users}/${this.state.friendly_urlRes}`}>Profile{!this.state.public_profile_flag && <span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> PRIVATE</span>}</Dropdown.Item>
                                  <Dropdown.Divider />
                                </React.Fragment>
                              }
                              {/*
                              {
                                (this.state.friendly_urlRes && !this.state.public_profile_flag) &&     
                                <React.Fragment>
                                  <Dropdown.Item><em>Profile is Private</em></Dropdown.Item>
                                  <Dropdown.Divider />
                                </React.Fragment>
                              }
                              */}

                              <Dropdown.Item as={NavLink} to={`${this.workspace_base_url}${local_routes.pklist}`}>My Presentations</Dropdown.Item>
                              <Dropdown.Divider />
                              {
                                (this.state.event_admin_flag || user_access_level === 'admin' || user_access_level === 'channel_admin' || user_access_level === 'location_admin') &&
                                <React.Fragment>
                                  <Dropdown.Item as={NavLink} to={`${this.workspace_base_url}${local_routes.myevents}`}>My Events</Dropdown.Item>
                                  <Dropdown.Divider />
                                </React.Fragment>
                              }
                            </React.Fragment>
                          }

                          {/*
                          {
                            this.state.org_info.map(org_obj => (
                            <React.Fragment key={org_obj.friendly_url}>
                              <Dropdown.Item href={`${local_routes.workspace}/${org_obj.friendly_url}`} eventKey={org_obj.friendly_url} onSelect={this.onWorkspaceChange}>
                                Switch to {org_obj.entity_name} {feature_names.Workspace}
                              </Dropdown.Item>
                              <Dropdown.Divider />
                            </React.Fragment>
                            ))
                          }
                          */}
                          
                          <Dropdown.Item onClick={this.logoutState}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    }
                  </Navbar>
                  



                </Container>
              </header>

              {/* Top Bar ends here */}

              {/* Menu starts here */}
              <div className={`sub-nav ${this.context.theme}`}>
                <div className={`sub-menu-nav sub-menu-nav-${this.context.theme}`}>
                  <Container fluid={this.menuContainerFluid}>
                  {/*<div className="container">*/}
                    {!this.workspace_base_url ?
                    <ul>
                      <li>
                        <NavLink to="/" exact={true} activeStyle={{ color: "#D12F50" }} >Featured</NavLink>{" "}
                      </li>
                      <li>
                        <NavLink to={`${local_routes.categories}`} activeStyle={{ color: "#D12F50" }}>Categories</NavLink>{" "}
                      </li>
                      <li>
                        <NavLink to={`${local_routes.channels}`} activeStyle={{ color: "#D12F50" }}>Channels</NavLink>{" "}
                      </li>
                      <li>
                        <NavLink to={`${local_routes.events}`} activeStyle={{ color: "#D12F50" }}>Events</NavLink>{" "}
                      </li>
                      <li>
                        <NavLink to={`${local_routes.cities}`} activeStyle={{ color: "#D12F50" }}>Cities</NavLink>{" "}
                      </li>
                      <li>
                        <NavLink style={{ marginTop: "-3px" }} to={pk_create_local_route} activeStyle={{ color: "#D12F50" }}>
                          Create
                          <span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> BETA</span>
                        </NavLink>{" "}
                      </li>
                      <li>
                        <a target="_blank" href={local_routes.shop} rel="noopener noreferrer">Shop</a>{" "}
                      </li>
                      <li>
                        <NavLink to={`${local_routes.about}`} activeStyle={{ color: "#D12F50" }}>About</NavLink>{" "}
                      </li>

                      { this.state.org_options.length > 0 && 
                          <li style={{ width: "200px", marginRight: "0px", marginLeft: "30px", float: "right" }}>
                            <Select
                              styles={{
                                menuPortal: base => ({ ...base, fontSize: "smaller", zIndex: 9999 })
                              }}
                              theme={theme => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  primary25: 'gray', // hover background color
                                  primary: 'lightgray', // selected background color
                                  neutral0: secondary_background_color, // non-selected, non-hover background color; also selected txt color
                                  neutral80: txt_color // non-selected menu item text color
                                },
                              })}
                              menuPortalTarget={document.querySelector('body')}
                              className='workspace_dropdown_menu'
                              //classNamePrefix=''
                              value={this.state.selected_org_option}
                              onChange={this.onDropdownWorkspaceChange}
                              options={this.state.org_options}
                            />
                          </li>
                      }
                      
                      { user_access_level === 'admin' &&
                        <React.Fragment>
                          <li style={{ marginRight: "0px", marginLeft: "30px", float: "right" }}>
                            <NavLink to={`${local_routes.managepechakucha}/main`} activeStyle={{ color: "#D12F50" }}>
                              Manage PechaKucha
                            </NavLink>
                          </li>
                          <li style={{ marginRight: "0px", marginLeft: "30px", float: "right" }}>
                            <NavLink to={local_routes.chats} activeStyle={{ color: "#D12F50" }}>
                              Chats
                            </NavLink>
                          </li>
                        </React.Fragment>
                      }
                      
                      { this.state.location_info.length > 0 &&
                        <li style={{ marginRight: "0px", marginLeft: "30px", float: "right" }}>
                          <NavLink to={`${local_routes.managecity}/${this.state.location_info[0].friendly_url}/main`} activeStyle={{ color: "#D12F50" }}>
                            Manage {this.state.location_info[0].entity_name}
                          </NavLink>
                        </li>
                      }
                      { this.state.channel_info.length > 0 &&
                        <li style={{ marginRight: "0px", marginLeft: "30px", float: "right" }}>
                          <NavLink to={`${this.workspace_base_url}${local_routes.managechannel}/${this.state.channel_info[0].friendly_url}/main`} activeStyle={{ color: "#D12F50" }}>
                            Manage {this.state.channel_info[0].entity_name}
                          </NavLink>
                        </li>
                      }
                      
                      { user_account_level === 'private' &&
                        <li style={{ marginRight: "0px", marginLeft: "30px", float: "right", color: "#E50114" }}>
                          <a>Pro Account</a>
                        </li>
                      }
                      
                      {/*                      
                      <li style={{ textTransform: "none", marginRight: "0px", marginLeft: "30px", float: "right", color: "#E50114" }}>
                        <a style={{ textTransform: "none",  color: "#E50114" }} target="_blank" rel="noopener" href={local_routes.waf_contest}>
                          Isolation Transformed - global design competition
                        </a>
                        <NavLink style={{textTransform: "none"}} to="/internationalpk" exact={true} activeStyle={{ color: "#D12F50" }} >NEW: International PK Day #ipk2020</NavLink>{" "}
                      </li>
                      */}
                      
                    </ul>
                    :
                    <ul>
                      <li>
                        <NavLink to={this.workspace_base_url} exact={true} activeStyle={{ color: "#D12F50" }}>Featured</NavLink>{" "}
                      </li>
                      <li>
                        <NavLink  to={`${this.workspace_base_url}${local_routes.events}`} activeStyle={{ color: "#D12F50" }}>Events</NavLink>{" "}
                      </li>
                      {/*
                      { org_account_level !== 'standard' &&
                      <React.Fragment>
                        <li>
                          <NavLink to={`${this.workspace_base_url}${local_routes.teams}`} activeStyle={{ color: "#D12F50" }}>{feature_names.Team}s</NavLink>{" "}
                        </li>
                      </React.Fragment>
                      }
                      */}
                      <li>
                        <NavLink  to={`${this.workspace_base_url}${local_routes.groups}`} activeStyle={{ color: "#D12F50" }}>Groups</NavLink>{" "}
                      </li>
                      <li>
                        <NavLink style={{ marginTop: "-3px" }} to={`${this.workspace_base_url}${pk_create_local_route}`} activeStyle={{ color: "#D12F50" }}>
                          Create
                          <span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> BETA</span>
                        </NavLink>{" "}
                      </li>
                      <li>
                        <a target="_blank" href={this.state.help_page_url || local_routes.help} rel="noopener noreferrer">Help</a>{" "}
                        {/* <NavLink target="_blank" to={`${local_routes.help}`}  activeStyle={{ color: "#D12F50" }}>Help</NavLink>{" "} */}
                      </li>

                      { this.state.org_options.length > 0 && 
                          <li style={{ width: "200px", marginRight: "0px", marginLeft: "30px", float: "right" }}>
                            <Select
                              styles={{ menuPortal: base => ({ ...base, fontSize: "smaller", zIndex: 9999 }) }}
                              theme={theme => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  primary25: 'gray', // hover background color
                                  primary: 'lightgray', // selected background color
                                  neutral0: secondary_background_color, // non-selected, non-hover background color; also selected txt color
                                  neutral80: txt_color // non-selected menu item text color
                                },
                              })}
                              menuPortalTarget={document.body}
                              className='workspace_dropdown_menu'
                              //classNamePrefix=''
                              //ref={this.select_ref}
                              //isDisabled={!this.props.editable}
                              //isDisabled={true}
                              //isOptionDisabled={true}
                              //closeMenuOnSelect={true}
                              //value={this.state.org_options[this.state.selected_org_option_index] || null}
                              value={this.state.selected_org_option}
                              //defaultValue={selectedPresenter}
                              onChange={this.onDropdownWorkspaceChange}
                              options={this.state.org_options}
                              //isMulti={this.props.multiple==="true" ? true : false}  
                            />
                          </li>
                      }

                      
                      { (user_access_level === 'admin' || organization_user_access_level === 'admin') &&
                       <React.Fragment>


                          <li style={{ marginRight: "0px", marginLeft: "30px", float: "right" }}>
                            <NavLink to={`${this.workspace_base_url}${local_routes.manageworkspace}/main`} activeStyle={{ color: "#D12F50" }}>
                              Manage {feature_names.Workspace}
                            </NavLink>
                          </li>
                        </React.Fragment>
                      }
                      
                    </ul>                    
                    }
                  </Container>
                </div>
                {/* Menu ends here */}
               
                {/* note that we can't use React.Fragment inside a Switch statement, so we need to duplicate shared routes in public and workspace sections */}
                {!this.workspace_base_url ?
                <Switch>
                  {/* shared routes */}
                  {/* <Route exact path={local_routes.groups} component={Groups} />
                  <Route path={`${local_routes.groups}/:friendly_url`} component={GroupDetails} /> */}
                  <Route path={local_routes.jobs} component={Jobs} />
                  <Route path={local_routes.pricing} component={Pricing} />
                  <Route exact path="/chats" component={AgoraVideoChatControl} />
                  <Route exact path="/agora_chats" component={AgoraVideoChatControl} />
                  {/* <Route path="/chats/:friendly_url" component={VideoChat} /> */}
                  <Route path="/pkcreate" component={PkCreateHome}/>
                  <Route path="/about" component={AboutPage} />                  
                  <Route path="/accountsettings" component={AccountSettings} />
                  <Route path="/privacypolicy" component={PrivacyPolicy} />
                  <Route path="/termsofuse" component={TermsofUse} />
                  <Route path="/copyrightpolicy" component={CopyRights} />
                  {/*
                  <Route path="/schools" component={Schools} />
                  <Route path="/hostevent" component={Hostevent} />
                  <Route path="/business" component={Business} />
                  */}
                  <Route path="/schools" render={() => window.location.href = local_routes.forschools} />
                  <Route path="/hostevent" render={() => window.location.href = local_routes.hostanevent} />
                  <Route path="/host-an-event" render={() => window.location.href = local_routes.hostanevent} />
                  <Route path="/business" render={() => window.location.href = local_routes.forbusiness} />
                  <Route path="/getonwithit" component={GetOnWithIt} />
                  <Route path="/internationalpk" component={InternationalPk2022} />
                  <Route path="/pkmaker" component={QuickCreate} />
                  <Route path="/internationalpk2021" component={InternationalPk2021} />
                  <Route path="/internationalpk2020" component={InternationalPk2020} />
                  <Route path="/creativegames" component={CreativeGames} />
                  <Route path="/press" component={Press} />
                  <Route exact path="/404" component={NotFound} />
                  <Route exact path="/error" component={UnknownError} />
                  <Route exact path="/accessrequired" component={AccessRequired} />

                  {/* public only routes  */}
                  {/* <Route exact path="/agorachat" component={AgoraChat} /> */}
                  <Route exact path="/" component={HomePage} />
                  <Route exact path="/pkcreation" component={pkCreation} /> {/* create PK */}
                  <Route path="/pkcreation/:entity_uuid/:otherpage" component={pkCreation} /> {/* edit PK */}
                  <Route path="/pkcreation/:entity_uuid" component={pkCreation} /> {/* edit PK */}
                  <Route path="/searchresults" component={searchResults} />
                  <Route path="/pklist" component={MyPks} />
                  <Route path={`/editcity/:friendly_url`} component={ManageCity} /> {/* handle old nav, if organizers bookmarked or something */}
                  <Route path={`/managecity/:friendly_url/:otherpage`} component={ManageCity} />
                  <Route path={`/managecity/:friendly_url`} component={ManageCity} /> {/* make it easier for organizers to type in the URL */}
                  <Route path={`/managechannel/:friendly_url/:otherpage`} component={ManageChannel} />
                  <Route path={`/managechannel/:friendly_url`} component={ManageChannel} /> 
                  <Route exact path="/manageevent" component={ManageEvent} />
                  <Route path={`/manageevent/:entity_uuid/:otherpage`} component={ManageEvent} />
                  <Route exact path="/categories" component={Category} />
                  <Route path="/categories/:friendly_url" component={categoryDetail} />                  
                  <Route path="/presentations/:friendly_url" component={Player} />                 
                  <Route exact path="/events" component={Events} />
                  <Route exact path="/events/calendar" component={EventCalendar} />
                  <Route path="/events/:friendly_url" component={EventDetail} />                  
                  <Route exact path="/cities" component={CityList} />
                  <Route path="/cities/:friendly_url" component={City} />
                  <Route exact path="/channels" component={Channels} />
                  <Route path="/channels/:friendly_url" component={Channelsdetail} />
                  <Route path="/users/:friendly_url" component={Profile} />
                  <Route path="/myevents" component={MyEvents} />
                  <Route exact path="/managepechakucha" component={ManagePechaKucha} />
                  <Route path="/managepechakucha/:otherpage" component={ManagePechaKucha} />
                  
                  {/* catch-all 404 page */}
                  <Route path="*" component={NotFound} />
                </Switch>
                :
                <Switch>
                  {/* shared routes */}
                  {/*
                  <Route path="/pkcreate" component={PkCreateHome}/>
                  <Route path="/about" component={AboutPage} />                  
                  <Route path="/accountsettings" component={AccountSettings} />
                  <Route path="/privacypolicy" component={PrivacyPolicy} />
                  <Route path="/termsofuse" component={TermsofUse} />
                  <Route path="/copyrightpolicy" component={CopyRights} />
                  <Route path="/schools" component={Schools} />
                  <Route path="/business" component={Business} />
                  <Route path="/hostevent" component={Hostevent} />
                  <Route path="/internationalpk" component={InternationalPk} />
                  <Route path="/creativegames" component={CreativeGames} />
                  <Route path="/press" component={Press} />
                  <Route exact path="/404" component={NotFound} />
                  <Route exact path="/error" component={UnknownError} />
                  */}
                  
                  {/* workspace only routes  */}
                  <Route exact path = "/" render={() => <Redirect to={this.workspace_base_url}/>}/>
                  <Route path={local_routes.workspace+"/:org_friendly_url"+local_routes.help} component={AboutPage} />
                  <Route path={local_routes.workspace+"/:org_friendly_url"+local_routes.accountsettings} component={AccountSettings} />
                  <Route exact path={local_routes.workspace+"/:org_friendly_url"} component={WorkspaceHomePage} />
                  <Route exact path={local_routes.workspace+"/:org_friendly_url"+local_routes.manageworkspace} component={ManageWorkspace} />
                  <Route exact path={local_routes.workspace+"/:org_friendly_url"+local_routes.manageworkspace+"/:otherpage"} component={ManageWorkspace} />
                  <Route exact path={local_routes.workspace+"/:org_friendly_url/pkcreation"} component={pkCreation} /> {/* create PK */}
                  <Route path={local_routes.workspace+"/:org_friendly_url/pkcreation/:entity_uuid/:otherpage"} component={pkCreation} /> {/* edit PK */}
                  <Route path={local_routes.workspace+"/:org_friendly_url/pkcreation/:entity_uuid"} component={pkCreation} /> {/* edit PK */}
                  <Route path={local_routes.workspace+"/:org_friendly_url/searchresults"} component={searchResults} />
                  <Route path={local_routes.workspace+"/:org_friendly_url/pklist"} component={MyPks} />
                  <Route exact path={`${local_routes.workspace}/:org_friendly_url${local_routes.groups}`} component={Groups} />
                  <Route path={`${local_routes.workspace}/:org_friendly_url${local_routes.groups}/:friendly_url`} component={GroupDetails} />
                  <Route path={`${local_routes.workspace}/:org_friendly_url${local_routes.manageteam}/:friendly_url/:otherpage`} component={ManageChannel} />
                  <Route path={`${local_routes.workspace}/:org_friendly_url${local_routes.manageteam}/:friendly_url`} component={ManageChannel} /> 
                  <Route exact path={`${local_routes.workspace}/:org_friendly_url/manageevent`} component={ManageEvent}/>
                  <Route path={`${local_routes.workspace}/:org_friendly_url/manageevent/:entity_uuid/:otherpage`} component={ManageEvent} />
                  {/*
                  <Route exact path=local_routes.workspace+"/:org_friendly_url/categories" component={Category} />
                  <Route path=local_routes.workspace+"/:org_friendly_url/categories/:friendly_url" component={categoryDetail} />
                  */}
                  <Route path={local_routes.workspace+"/:org_friendly_url/presentations/:friendly_url"} component={Player} />
                  <Route exact path={local_routes.workspace+"/:org_friendly_url/events"} component={Events} />
                  <Route path={local_routes.workspace+"/:org_friendly_url/events/:friendly_url"} component={EventDetail} />
                  {/* <Route exact path={local_routes.workspace+"/:org_friendly_url"+local_routes.teams} component={Channels} />
                  <Route path={local_routes.workspace+"/:org_friendly_url"+local_routes.teams+"/:friendly_url"} component={Channelsdetail} /> */}
                  <Route path={local_routes.workspace+"/:org_friendly_url/users/:friendly_url"} component={Profile} />
                  <Route path={local_routes.workspace+"/:org_friendly_url/myevents"} component={MyEvents} />
                  <Route exact path={local_routes.workspace+"/:org_friendly_url"+local_routes.not_found} component={NotFound} />
                  <Route exact path={local_routes.workspace+"/:org_friendly_url"+local_routes.error} component={UnknownError} />
                  
                  {/* catch-all 404 page */}
                  <Route exact path="/404" component={NotFound} />
                  <Route exact path="/error" component={UnknownError} />
                  <Route exact path="/accessrequired" component={AccessRequired} />
                  <Route path="*" component={NotFound} />
                </Switch>
                }
              </div>
            </div>
          ) : (
              <React.Fragment>
                {/* without container pages */}
                { (window.location.pathname.startsWith('/chats/') && user_Status === 1) &&
                  <PKWebSocket
                    user_uuid={user_entity_uuid}
                    user_token={user_access_token}
                    OnRing={this.OnRing}
                    OnUpdateUserContext={this.OnUpdateUserContext}
                  />
                }
                {!this.workspace_base_url ?
                  
                  <Switch>
                    <Route path="/chats/:friendly_url" component={AgoraVideoChat} />
                    <Route path="/agora_chats/:friendly_url" component={AgoraVideoChat} />
                    <Route exact path="/linkedin" component={LinkedInPopUp} />
                    
                    <Route path="/login" component={Login} />
                    <Route path="/register" component={Register} />
                    <Route path="/aboutyourself" component={AboutYourself} />
                    <Route path="/runofshowplay/:friendly_url/:start_leaf" component={RunofShowPlay} />
                    <Route path={local_routes.sendresetpasswordemail} component={EmailVerification} />
                    <Route path={`/resetpassword/:resetpassword_token?`} component={ResetPassword} />
                    <Route path="/banner" component={Banner} />
                    <Route path="/embed/presentations/:friendly_url" component={EmbeddedPlayer} />
                  </Switch>
                  :
                  <Switch>
                    <Route path={local_routes.workspace+"/:org_friendly_url/runofshowplay/:friendly_url/:start_leaf"} component={RunofShowPlay} />
                  </Switch>
                }
              </React.Fragment>
          )}
          <Zendesk zendeskKey={ZENDESK_KEY} onLoaded={() => this.ZendeskDidLoad()} />
        </React.Fragment>
        
      );
    
    // eslint-disable-next-line 
    //window.prerenderReady = true;
  }
  
  ZendeskDidLoad = () => {
    //console.log('Zendesk is loaded');
    //ZendeskAPI("webWidget", "setLocale", "de");
    if (window.location.pathname.startsWith('/embed/') || window.location.pathname.startsWith('/agora_chats/') || window.location.pathname.startsWith('/chats/') || window.location.pathname.startsWith('/runofshowplay/')) {
      ZendeskAPI("webWidget", "hide");
    }
  }

}
//Menu.contextType = UserContext;

export default withRouter(Menu);